<template>
  <div class="login">

    <div class="form_box">
      <div class="left">
        <div class="left_title">
          <div>校派智能客服</div>
          <div>电话后台</div>
        </div>
        <div class="left_img">
          <img src="https://xiaopai-java.oss-cn-hangzhou.aliyuncs.com/zyb/img/20210930/1632968660.png">
        </div>
      </div>
      <div class="right">
        <div class="right_title">登录</div>
        <div class="form_item">
          <div class="input_icon">
            <img src="https://xiaopai-java.oss-cn-hangzhou.aliyuncs.com/zyb/img/20210930/1632969010.png">
          </div>
          <input style="-webkit-box-shadow: 0 0 0 1000px #EDEFF4 inset;outline:none;" v-model="loginForm.user_name"
            class="item_input" type="text" placeholder="请输入用户名" />
        </div>
        <div class="form_item">
          <div class="input_icon">
            <img src="https://xiaopai-java.oss-cn-hangzhou.aliyuncs.com/zyb/img/20210930/1632969175.png">
          </div>
          <input style="-webkit-box-shadow: 0 0 0 1000px #EDEFF4 inset;outline:none;" v-model="loginForm.password"
            type="password" class="item_input" @keyup.enter="authLogin" placeholder="请输入密码">
          </input>
        </div>
        <div class="form_submit" @click="loginDataAuth">登录</div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom_title1">— 校派智能高招 让招办工作更轻松 —</div>

    </div>
  </div>
</template>

<script>
import { login } from '@/api/login'
export default {
  name: "login",
  data() {
    return {
      loginForm: {
        //  账号
        user_name: '',
        //  密码
        password: '',
      },
    }
  },
  computed: {

  },
  methods: {
    authLogin() {
      this.loginDataAuth()
    },
    async loginDataAuth() {
      let _this = this
      const res = await login(this.loginForm)
      window.sessionStorage.removeItem('is_xiaopai')
      if (res.code === 1) {
        if (res.data.is_xiaopai) {
          window.sessionStorage.setItem('is_xiaopai', res.data.token)
          _this.$router.replace({
            path: '/openAccount'
          })

        } else {
          window.sessionStorage.setItem('token', res.data.token)
          _this.$router.replace({ path: '/index' })
        }

      }
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
.login {
  position: fixed;
  width: 100%;
  height: 100%;
  margin-top: -10px;
  background-color: #F9FAFC;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .el-input__inner {
    width: 252px;
    height: 48px;
    line-height: 48px;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #ccc;
    font-size: 14px;
    color: #000;
  }
}

.login .logo {
  width: 72px;
  height: 24px;
  margin: 28px 0 0 30px;
}

.login .logo img {
  width: 72px;
  height: 24px;
}

.login .form_box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: 960px;
  height: 560px;
  background: #fff;
  box-shadow: 0px 7px 17px 0px rgba(32, 80, 127, 0.06), 1px 0px 4px 0px rgba(59, 124, 255, 0.1);
  border-radius: 10px;
}

.form_box .left {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 544px;
  height: 560px;
}

.left .left_title {
  height: 80px;
  font-size: 28px;
  font-weight: 800;
  color: #303133;
  line-height: 40px;
  letter-spacing: 2px;
  margin-top: 60px;
  text-align: center;
}

.left .left_img {
  width: 360px;
  height: 270px;
  margin-top: 40px;
}

.left .left_img img {
  width: 360px;
  height: 270px;
}

.form_box .right {
  width: 320px;
  height: 560px;
  margin-left: 11px;
}

.right .right_title {
  font-size: 24px;
  font-weight: 400;
  color: #000000;
  line-height: 100px;
  letter-spacing: 1px;
  margin-top: 60px;
  margin-bottom: 32px;
}

.right .form_item {
  display: flex;
  align-items: center;
  width: 320px;
  height: 48px;
  background-color: #EDEFF4;
  border-radius: 28px;
  margin-bottom: 24px;
  overflow: hidden;
}

.form_item .input_icon {
  width: 20px;
  height: 20px;
  margin-left: 18px;
  margin-right: 10px;
}

.form_item .input_icon img {
  width: 20px;
  height: 20px;
}

.form_item .item_input {
  width: 250px;
  height: 48px;
  font-size: 14px;
  color: #000;
  font-weight: 500;
  background-color: #EDEFF4;
  border: 0;
}

.right .form_select {
  width: 252px;
  height: 48px;
  margin-bottom: 20px;
}



.right .form_submit {
  width: 148px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  font-size: 16px;
  text-align: center;
  background: #3B7CFF;
  box-shadow: 0px 5px 20px 0px rgba(59, 124, 255, 0.2);
  border-radius: 24px;
  margin-top: 72px;
  color: #fff;
  cursor: pointer;
}

.bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 60px;
  width: 100vw;
}

.bottom .bottom_title1 {
  font-size: 12px;
  font-weight: 400;
  color: #303133;
}

.bottom .bottom_title2 {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
  margin-top: 14px;
}
</style>
